export function createEmptyAddress(name) {
    const address = {
        email: '',
        // These are just commented out so we know that they can be there.
        // fullName: '',
        // firstName: '',
        // lastName: '',
        company: '',
        address1: '',
        address2: '',
        city: '',
        stateId: '',
        zipcode: '',
        country: 'US',
        phone: '',
    }

    // if we get given a name to begin with then set that as fullName
    // Otherwise fallback to seperate firstName and lastName
    if (name) address.fullName = name
    else {
        address.firstName = ''
        address.lastName = ''
    }

    return address
}
